import styled from "styled-components";

const LockIcon = styled.span`
  margin-right: 4px;
  position: relative;
`;

export default LockIcon;
